import "./App.css";
import Header from "./components/Header/Header";
import "./main.css";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import ScanDashboard from "./pages/scan/ScanDashboard";
import TemplatesPage from "./pages/templates/TemplatesPage";
import NamingRulesPage from "./pages/namingRules/NamingRulesPage";
import ErrorPage from "./pages/error/ErrorPage";
import LoginPage from "./pages/login/LoginPage";
import { SettingProvider } from "./contexts/setting/SettingContext";
import { isAuthenticated } from "./services/auth";
const Layout = () => (
  <SettingProvider>
    <div>
      <Header />
      <Outlet />
    </div>
  </SettingProvider>
);

const ProtectedRoute = () => {
  const authenticated = isAuthenticated();

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

const PublicRoute = ({ children }) => {
  const authenticated = isAuthenticated();

  if (authenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      // Error boundary for this route segment
      errorElement: <ErrorPage />,
      // Wrap the entire application in the ProtectedRoute guard
      element: <ProtectedRoute />,
      children: [
        {
          element: <Layout />,
          children: [
            {
              // Default route (Dashboard)
              index: true,
              element: <ScanDashboard />,
            },
            {
              // Path: /templates
              path: "templates",
              element: <TemplatesPage />,
            },
            {
              // Path: /naming-rules
              path: "naming-rules",
              element: <NamingRulesPage />,
            },
          ],
        },
      ],
    },
    {
      path: "/login",
      element: (
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      ),
    },
    {
      // Catch-all route for 404 Not Found
      path: "*",
      element: <div>404 - Page Not Found</div>,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default App;
